<template>
  <div class="TextAnime1">
    <div>
      <span v-for="(t, index) in text" :key="index" v-text="t" class="item delay-anime"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: 'Weboarでは仲間と楽しく仕事ができる環境を大切にできて、最後までやりきるという強い責任感と思いを持った仲間を求めています',
    }
  }
}
</script>

<style lang="stylus" scoped>
@keyframes text-in {
  0% {
    transform: translate(0, -20px);
    opacity: 0;
  }
}

.item {
  display: inline-block;
  min-width: 0.3em;
  font-size: 2rem;
  animation: text-in 0.8s cubic-bezier(0.22, 0.15, 0.25, 1.43) 0s backwards;
  font-size: 18px;
  color: #fff;
  font-weight: bold;
}

@media screen and (max-width:420px) {
  .item {
    font-size: 12px;
  }
}

for co in 0 .. 62 {
  .delay-anime:nth-child({co + 1}) {
    animation-delay: co * 30ms;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/animation/TextAnime4.vue